import store from '@/store';

const account = () => store.state.info.account;
export const verifyAdmin = (to, from, next) => {
  if (account().role === 'admin') next();
  else next('/403');
};
